module.exports = "/_next/static/images/CollectionSourceFunctions@2x-e00ccc9652e7da0dbf31a619d46797ca.webp";